import { createSlice } from "@reduxjs/toolkit";

import { getMeta } from "./actions";

const initialState = {
  meta: null,
};

const metaSlice = createSlice({
  name: "meta",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMeta.fulfilled, (state, action) => {
      state.meta = action.payload;
    });
  },
});

export default metaSlice.reducer;
